import { DialogContentOptions, FormGroup, react } from "../../../omnia"
import { PlanApi } from "../../api"
import { PlanAction } from "../../reducer"
import { PlanState } from "../../types"

export function setupYear(state: PlanState, api: PlanApi, dispatch: React.Dispatch<PlanAction>) {

    const { year } = api
    const { plans } = state

    const contentProps = {
        years: plans.filter(y => y !== year),
        targetYear: year
    }

    return react.showDialog<typeof contentProps, number>({
        content: SetupYearContent,
        contentProps: {
            years: plans.filter(y => y !== year),
            targetYear: year
        }
    }).then(sourceYear => {

        if (sourceYear) {
            return api.setupCurrentYear(sourceYear).then(data => dispatch({ type: "load", data }))
        }

    })
}


interface Props extends DialogContentOptions<number> {
    targetYear: number
    years: number[]
}

function SetupYearContent({ years, targetYear, close }: Props) {

    const [sourceYear, setSourceYear] = React.useState<number>()

    return <>

        <react.DialogHeader>
            Reset and initialise year {targetYear}
        </react.DialogHeader>

        <div className="modal-body material-form">

            <p>
                This command will reset and initialise the plan for year {targetYear} from another year.
            </p>

            <div style={{ margin: "1em", display: "flex", alignItems: "baseline" }}>

                <span style={{ marginRight: "10px" }}>
                    Please select the source year from this list:
                </span>

                <FormGroup>
                    <select className="form-control" value={sourceYear || 0} onChange={e => setSourceYear(Number(e.target.value))} style={{ width: "auto" }}>
                        <option></option>
                        {
                            years.map(y => <option key={y} value={y}>{y}</option>)
                        }
                    </select>
                </FormGroup>

            </div>

            <p style={{ margin: "1.5em 0 1em 0", color: "#F44336", textAlign: "center" }}>
                <i className="fas fa-exclamation-triangle"></i>
                <strong>Warning</strong>: Year {targetYear} will be completely reset. This operation is irreversible.
            </p>

        </div>

        <div className="modal-footer">

            <button className="btn btn-warning" type="button" onClick={() => close(undefined)}>
                Cancel
            </button>

            <button className="btn btn-success" type="button" onClick={() => close(sourceYear)} disabled={!sourceYear}>
                Initialise year {targetYear}
            </button>

        </div>
    </>

}
